import backendV2Service from './backend-v2.service';

export interface CreateTeacherPayload {
  firstname: string;
  lastname: string;
  lastname2nd?: string;
  email?: string;
  dni?: string;
  birthDate?: string;
  baseCountryId: number;
  schoolId: number;
  courseIds?: number[];
}

export interface CreateTeacherResult {
  status: string;
  content: { id: number; username: string; passwordTmp: string };
}

const unwrap = <T>(req: Promise<{ data: T }>) => req.then(({ data }) => data);

export default {
  create: (payload: CreateTeacherPayload): Promise<CreateTeacherResult> => unwrap(
    backendV2Service.post<CreateTeacherResult>('/teachers', payload),
  ),
};
